export default function (isInDialog = false) {
  return {
    rail: {
      size: '8px',
      background: isInDialog ? '#000000' : '#ffffff',
      opacity: isInDialog ? 0.15 : 0.2,
      gutterOfSide: '5px',
    },
    bar: {
      onlyShowBarOnScroll: false,
      background: isInDialog ? '#000000' : '#ffffff',
      opacity: isInDialog ? 0.25 : 0.4,
      keepShow: true,
    },
  }
}